// 导入request 
import request from './request'
const http = {
    /**
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url, params, contentType = true, responseType = false) {
        const config = {
            method: 'get',
            url: url,
            contentType: contentType ? 'application/json' : 'application/x-www-form-urlencoded',
        }
        if (responseType) {
            config.responseType = 'blob'
        }
        if (params) {
            config.params = params

        }
        return request(config)
    },
    post(url, data, contentType = true) {
        const config = {
            method: 'post',
            url: url,
            contentType: contentType ? 'application/json' : 'application/x-www-form-urlencoded'
        }
        if (!contentType) {
            if (process.client) {
                var formData = new FormData();
                for (let key in data) { formData.append(key, data[key]) }
            }
        }
        if (data) config.data = contentType ? data : formData
        return request(config)
    },
}


export default http